"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttons = void 0;
var _euiThemeCommon = require("@elastic/eui-theme-common");
var _semantic_colors = require("./colors/_semantic_colors");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
var getTokenByVariant = function getTokenByVariant(buttonVariant, tokens) {
  switch (buttonVariant) {
    case 'refresh':
      return tokens.refresh;
    default:
      {
        return tokens.classic;
      }
  }
};
var _buttons = {
  backgroundPrimary: (0, _euiThemeCommon.computed)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      backgroundLightPrimary = _ref2[0];
    return backgroundLightPrimary;
  }, ['colors.backgroundLightPrimary']),
  backgroundAccent: (0, _euiThemeCommon.computed)(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      backgroundLightAccent = _ref4[0];
    return backgroundLightAccent;
  }, ['colors.backgroundLightAccent']),
  backgroundAccentSecondary: (0, _euiThemeCommon.computed)(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      backgroundLightAccentSecondary = _ref6[0];
    return backgroundLightAccentSecondary;
  }, ['colors.backgroundLightAccentSecondary']),
  backgroundNeutral: (0, _euiThemeCommon.computed)(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      backgroundLightNeutral = _ref8[0];
    return backgroundLightNeutral;
  }, ['colors.backgroundLightNeutral']),
  backgroundSuccess: (0, _euiThemeCommon.computed)(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 1),
      backgroundLightSuccess = _ref10[0];
    return backgroundLightSuccess;
  }, ['colors.backgroundLightSuccess']),
  backgroundWarning: (0, _euiThemeCommon.computed)(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 1),
      backgroundLightWarning = _ref12[0];
    return backgroundLightWarning;
  }, ['colors.backgroundLightWarning']),
  backgroundRisk: (0, _euiThemeCommon.computed)(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 1),
      backgroundLightRisk = _ref14[0];
    return backgroundLightRisk;
  }, ['colors.backgroundLightRisk']),
  backgroundDanger: (0, _euiThemeCommon.computed)(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 1),
      backgroundLightDanger = _ref16[0];
    return backgroundLightDanger;
  }, ['colors.backgroundLightDanger']),
  backgroundText: (0, _euiThemeCommon.computed)(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 3),
      buttonVariant = _ref18[0],
      backgroundBasePlain = _ref18[1],
      backgroundLightText = _ref18[2];
    return getTokenByVariant(buttonVariant, {
      refresh: backgroundBasePlain,
      classic: backgroundLightText
    });
  }, ['flags.buttonVariant', 'colors.backgroundBasePlain', 'colors.backgroundLightText']),
  backgroundDisabled: (0, _euiThemeCommon.computed)(function (_ref19) {
    var _ref20 = _slicedToArray(_ref19, 1),
      backgroundBaseDisabled = _ref20[0];
    return backgroundBaseDisabled;
  }, ['colors.backgroundBaseDisabled']),
  backgroundPrimaryHover: _semantic_colors.SEMANTIC_COLORS.primary70Alpha12,
  backgroundAccentHover: _semantic_colors.SEMANTIC_COLORS.accent70Alpha12,
  backgroundAccentSecondaryHover: _semantic_colors.SEMANTIC_COLORS.accentSecondary70Alpha12,
  backgroundNeutralHover: _semantic_colors.SEMANTIC_COLORS.neutral70Alpha12,
  backgroundSuccessHover: _semantic_colors.SEMANTIC_COLORS.success70Alpha12,
  backgroundWarningHover: _semantic_colors.SEMANTIC_COLORS.warning60Alpha16,
  backgroundRiskHover: _semantic_colors.SEMANTIC_COLORS.risk60Alpha16,
  backgroundDangerHover: _semantic_colors.SEMANTIC_COLORS.danger70Alpha12,
  backgroundTextHover: _semantic_colors.SEMANTIC_COLORS.primary100Alpha8,
  backgroundPrimaryActive: _semantic_colors.SEMANTIC_COLORS.primary70Alpha16,
  backgroundAccentActive: _semantic_colors.SEMANTIC_COLORS.accent70Alpha16,
  backgroundAccentSecondaryActive: _semantic_colors.SEMANTIC_COLORS.accentSecondary70Alpha16,
  backgroundNeutralActive: _semantic_colors.SEMANTIC_COLORS.neutral70Alpha16,
  backgroundSuccessActive: _semantic_colors.SEMANTIC_COLORS.success70Alpha16,
  backgroundWarningActive: _semantic_colors.SEMANTIC_COLORS.warning60Alpha20,
  backgroundRiskActive: _semantic_colors.SEMANTIC_COLORS.risk60Alpha20,
  backgroundDangerActive: _semantic_colors.SEMANTIC_COLORS.danger70Alpha16,
  backgroundTextActive: _semantic_colors.SEMANTIC_COLORS.primary100Alpha12,
  backgroundFilledPrimary: (0, _euiThemeCommon.computed)(function (_ref21) {
    var _ref22 = _slicedToArray(_ref21, 1),
      backgroundFilledPrimary = _ref22[0];
    return backgroundFilledPrimary;
  }, ['colors.backgroundFilledPrimary']),
  backgroundFilledAccent: (0, _euiThemeCommon.computed)(function (_ref23) {
    var _ref24 = _slicedToArray(_ref23, 1),
      backgroundFilledAccent = _ref24[0];
    return backgroundFilledAccent;
  }, ['colors.backgroundFilledAccent']),
  backgroundFilledAccentSecondary: (0, _euiThemeCommon.computed)(function (_ref25) {
    var _ref26 = _slicedToArray(_ref25, 1),
      backgroundFilledAccentSecondary = _ref26[0];
    return backgroundFilledAccentSecondary;
  }, ['colors.backgroundFilledAccentSecondary']),
  backgroundFilledNeutral: (0, _euiThemeCommon.computed)(function (_ref27) {
    var _ref28 = _slicedToArray(_ref27, 1),
      backgroundFilledNeutral = _ref28[0];
    return backgroundFilledNeutral;
  }, ['colors.backgroundFilledNeutral']),
  backgroundFilledSuccess: (0, _euiThemeCommon.computed)(function (_ref29) {
    var _ref30 = _slicedToArray(_ref29, 1),
      backgroundFilledSuccess = _ref30[0];
    return backgroundFilledSuccess;
  }, ['colors.backgroundFilledSuccess']),
  backgroundFilledWarning: (0, _euiThemeCommon.computed)(function (_ref31) {
    var _ref32 = _slicedToArray(_ref31, 1),
      backgroundFilledWarning = _ref32[0];
    return backgroundFilledWarning;
  }, ['colors.backgroundFilledWarning']),
  backgroundFilledRisk: (0, _euiThemeCommon.computed)(function (_ref33) {
    var _ref34 = _slicedToArray(_ref33, 1),
      backgroundFilledRisk = _ref34[0];
    return backgroundFilledRisk;
  }, ['colors.backgroundFilledRisk']),
  backgroundFilledDanger: (0, _euiThemeCommon.computed)(function (_ref35) {
    var _ref36 = _slicedToArray(_ref35, 1),
      backgroundFilledDanger = _ref36[0];
    return backgroundFilledDanger;
  }, ['colors.backgroundFilledDanger']),
  backgroundFilledText: (0, _euiThemeCommon.computed)(function (_ref37) {
    var _ref38 = _slicedToArray(_ref37, 1),
      backgroundFilledText = _ref38[0];
    return backgroundFilledText;
  }, ['colors.backgroundFilledText']),
  backgroundFilledDisabled: (0, _euiThemeCommon.computed)(function (_ref39) {
    var _ref40 = _slicedToArray(_ref39, 1),
      backgroundBaseDisabled = _ref40[0];
    return backgroundBaseDisabled;
  }, ['colors.backgroundBaseDisabled']),
  backgroundFilledPrimaryHover: _semantic_colors.SEMANTIC_COLORS.primary100,
  backgroundFilledAccentHover: _semantic_colors.SEMANTIC_COLORS.accent100,
  backgroundFilledAccentSecondaryHover: _semantic_colors.SEMANTIC_COLORS.accentSecondary100,
  backgroundFilledNeutralHover: _semantic_colors.SEMANTIC_COLORS.neutral100,
  backgroundFilledSuccessHover: _semantic_colors.SEMANTIC_COLORS.success100,
  backgroundFilledWarningHover: _semantic_colors.SEMANTIC_COLORS.warning50,
  backgroundFilledRiskHover: _semantic_colors.SEMANTIC_COLORS.risk80,
  backgroundFilledDangerHover: _semantic_colors.SEMANTIC_COLORS.danger100,
  backgroundFilledTextHover: _semantic_colors.SEMANTIC_COLORS.shade100,
  backgroundFilledPrimaryActive: _semantic_colors.SEMANTIC_COLORS.primary110,
  backgroundFilledAccentActive: _semantic_colors.SEMANTIC_COLORS.accent110,
  backgroundFilledAccentSecondaryActive: _semantic_colors.SEMANTIC_COLORS.accentSecondary110,
  backgroundFilledNeutralActive: _semantic_colors.SEMANTIC_COLORS.neutral110,
  backgroundFilledSuccessActive: _semantic_colors.SEMANTIC_COLORS.success110,
  backgroundFilledWarningActive: _semantic_colors.SEMANTIC_COLORS.warning60,
  backgroundFilledRiskActive: _semantic_colors.SEMANTIC_COLORS.risk90,
  backgroundFilledDangerActive: _semantic_colors.SEMANTIC_COLORS.danger110,
  backgroundFilledTextActive: _semantic_colors.SEMANTIC_COLORS.shade110,
  backgroundEmptyPrimaryHover: _semantic_colors.SEMANTIC_COLORS.primary70Alpha12,
  backgroundEmptyAccentHover: _semantic_colors.SEMANTIC_COLORS.accent70Alpha12,
  backgroundEmptyAccentSecondaryHover: _semantic_colors.SEMANTIC_COLORS.accentSecondary70Alpha12,
  backgroundEmptyNeutralHover: _semantic_colors.SEMANTIC_COLORS.neutral70Alpha12,
  backgroundEmptySuccessHover: _semantic_colors.SEMANTIC_COLORS.success70Alpha12,
  backgroundEmptyWarningHover: _semantic_colors.SEMANTIC_COLORS.warning60Alpha16,
  backgroundEmptyRiskHover: _semantic_colors.SEMANTIC_COLORS.risk60Alpha16,
  backgroundEmptyDangerHover: _semantic_colors.SEMANTIC_COLORS.danger70Alpha12,
  backgroundEmptyTextHover: _semantic_colors.SEMANTIC_COLORS.primary100Alpha8,
  backgroundEmptyPrimaryActive: _semantic_colors.SEMANTIC_COLORS.primary70Alpha16,
  backgroundEmptyAccentActive: _semantic_colors.SEMANTIC_COLORS.accent70Alpha16,
  backgroundEmptyAccentSecondaryActive: _semantic_colors.SEMANTIC_COLORS.accentSecondary70Alpha16,
  backgroundEmptyNeutralActive: _semantic_colors.SEMANTIC_COLORS.neutral70Alpha16,
  backgroundEmptySuccessActive: _semantic_colors.SEMANTIC_COLORS.success70Alpha16,
  backgroundEmptyWarningActive: _semantic_colors.SEMANTIC_COLORS.warning60Alpha20,
  backgroundEmptyRiskActive: _semantic_colors.SEMANTIC_COLORS.risk60Alpha20,
  backgroundEmptyDangerActive: _semantic_colors.SEMANTIC_COLORS.danger70Alpha16,
  backgroundEmptyTextActive: _semantic_colors.SEMANTIC_COLORS.primary100Alpha12,
  textColorPrimary: (0, _euiThemeCommon.computed)(function (_ref41) {
    var _ref42 = _slicedToArray(_ref41, 1),
      textPrimary = _ref42[0];
    return textPrimary;
  }, ['colors.textPrimary']),
  textColorAccent: (0, _euiThemeCommon.computed)(function (_ref43) {
    var _ref44 = _slicedToArray(_ref43, 1),
      textAccent = _ref44[0];
    return textAccent;
  }, ['colors.textAccent']),
  textColorAccentSecondary: (0, _euiThemeCommon.computed)(function (_ref45) {
    var _ref46 = _slicedToArray(_ref45, 1),
      textAccentSecondary = _ref46[0];
    return textAccentSecondary;
  }, ['colors.textAccentSecondary']),
  textColorNeutral: (0, _euiThemeCommon.computed)(function (_ref47) {
    var _ref48 = _slicedToArray(_ref47, 1),
      textNeutral = _ref48[0];
    return textNeutral;
  }, ['colors.textNeutral']),
  textColorSuccess: (0, _euiThemeCommon.computed)(function (_ref49) {
    var _ref50 = _slicedToArray(_ref49, 1),
      textSuccess = _ref50[0];
    return textSuccess;
  }, ['colors.textSuccess']),
  textColorWarning: (0, _euiThemeCommon.computed)(function (_ref51) {
    var _ref52 = _slicedToArray(_ref51, 1),
      textWarning = _ref52[0];
    return textWarning;
  }, ['colors.textWarning']),
  textColorRisk: (0, _euiThemeCommon.computed)(function (_ref53) {
    var _ref54 = _slicedToArray(_ref53, 1),
      textRisk = _ref54[0];
    return textRisk;
  }, ['colors.textRisk']),
  textColorDanger: (0, _euiThemeCommon.computed)(function (_ref55) {
    var _ref56 = _slicedToArray(_ref55, 1),
      textDanger = _ref56[0];
    return textDanger;
  }, ['colors.textDanger']),
  textColorText: (0, _euiThemeCommon.computed)(function (_ref57) {
    var _ref58 = _slicedToArray(_ref57, 1),
      textParagraph = _ref58[0];
    return textParagraph;
  }, ['colors.textParagraph']),
  textColorDisabled: (0, _euiThemeCommon.computed)(function (_ref59) {
    var _ref60 = _slicedToArray(_ref59, 1),
      textDisabled = _ref60[0];
    return textDisabled;
  }, ['colors.textDisabled']),
  textColorFilledPrimary: (0, _euiThemeCommon.computed)(function (_ref61) {
    var _ref62 = _slicedToArray(_ref61, 1),
      textInverse = _ref62[0];
    return textInverse;
  }, ['colors.textInverse']),
  textColorFilledAccent: (0, _euiThemeCommon.computed)(function (_ref63) {
    var _ref64 = _slicedToArray(_ref63, 1),
      textInverse = _ref64[0];
    return textInverse;
  }, ['colors.textInverse']),
  textColorFilledAccentSecondary: (0, _euiThemeCommon.computed)(function (_ref65) {
    var _ref66 = _slicedToArray(_ref65, 1),
      textInverse = _ref66[0];
    return textInverse;
  }, ['colors.textInverse']),
  textColorFilledNeutral: (0, _euiThemeCommon.computed)(function (_ref67) {
    var _ref68 = _slicedToArray(_ref67, 1),
      textInverse = _ref68[0];
    return textInverse;
  }, ['colors.textInverse']),
  textColorFilledSuccess: (0, _euiThemeCommon.computed)(function (_ref69) {
    var _ref70 = _slicedToArray(_ref69, 1),
      textInverse = _ref70[0];
    return textInverse;
  }, ['colors.textInverse']),
  textColorFilledWarning: _semantic_colors.SEMANTIC_COLORS.warning110,
  textColorFilledRisk: (0, _euiThemeCommon.computed)(function (_ref71) {
    var _ref72 = _slicedToArray(_ref71, 1),
      textInverse = _ref72[0];
    return textInverse;
  }, ['colors.textInverse']),
  textColorFilledDanger: (0, _euiThemeCommon.computed)(function (_ref73) {
    var _ref74 = _slicedToArray(_ref73, 1),
      textInverse = _ref74[0];
    return textInverse;
  }, ['colors.textInverse']),
  textColorFilledText: (0, _euiThemeCommon.computed)(function (_ref75) {
    var _ref76 = _slicedToArray(_ref75, 1),
      textInverse = _ref76[0];
    return textInverse;
  }, ['colors.textInverse']),
  textColorFilledDisabled: (0, _euiThemeCommon.computed)(function (_ref77) {
    var _ref78 = _slicedToArray(_ref77, 1),
      textDisabled = _ref78[0];
    return textDisabled;
  }, ['colors.textDisabled'])
};
var _dark_buttons = _objectSpread(_objectSpread({}, _buttons), {}, {
  backgroundPrimaryHover: _semantic_colors.SEMANTIC_COLORS.primary70Alpha16,
  backgroundAccentHover: _semantic_colors.SEMANTIC_COLORS.accent70Alpha16,
  backgroundAccentSecondaryHover: _semantic_colors.SEMANTIC_COLORS.accentSecondary70Alpha16,
  backgroundNeutralHover: _semantic_colors.SEMANTIC_COLORS.neutral70Alpha16,
  backgroundSuccessHover: _semantic_colors.SEMANTIC_COLORS.success70Alpha16,
  backgroundWarningHover: _semantic_colors.SEMANTIC_COLORS.warning60Alpha12,
  backgroundRiskHover: _semantic_colors.SEMANTIC_COLORS.risk60Alpha12,
  backgroundDangerHover: _semantic_colors.SEMANTIC_COLORS.danger70Alpha16,
  backgroundTextHover: _semantic_colors.SEMANTIC_COLORS.plainLightAlpha12,
  backgroundPrimaryActive: _semantic_colors.SEMANTIC_COLORS.primary70Alpha20,
  backgroundAccentActive: _semantic_colors.SEMANTIC_COLORS.accent70Alpha20,
  backgroundAccentSecondaryActive: _semantic_colors.SEMANTIC_COLORS.accentSecondary70Alpha20,
  backgroundNeutralActive: _semantic_colors.SEMANTIC_COLORS.neutral70Alpha20,
  backgroundSuccessActive: _semantic_colors.SEMANTIC_COLORS.success70Alpha20,
  backgroundWarningActive: _semantic_colors.SEMANTIC_COLORS.warning60Alpha16,
  backgroundRiskActive: _semantic_colors.SEMANTIC_COLORS.risk60Alpha16,
  backgroundDangerActive: _semantic_colors.SEMANTIC_COLORS.danger70Alpha20,
  backgroundTextActive: _semantic_colors.SEMANTIC_COLORS.plainLightAlpha16,
  backgroundFilledPrimaryHover: _semantic_colors.SEMANTIC_COLORS.primary70,
  backgroundFilledAccentHover: _semantic_colors.SEMANTIC_COLORS.accent70,
  backgroundFilledAccentSecondaryHover: _semantic_colors.SEMANTIC_COLORS.accentSecondary70,
  backgroundFilledNeutralHover: _semantic_colors.SEMANTIC_COLORS.neutral70,
  backgroundFilledSuccessHover: _semantic_colors.SEMANTIC_COLORS.success70,
  backgroundFilledWarningHover: _semantic_colors.SEMANTIC_COLORS.warning50,
  backgroundFilledRiskHover: _semantic_colors.SEMANTIC_COLORS.risk60,
  backgroundFilledDangerHover: _semantic_colors.SEMANTIC_COLORS.danger70,
  backgroundFilledTextHover: _semantic_colors.SEMANTIC_COLORS.shade70,
  backgroundFilledPrimaryActive: _semantic_colors.SEMANTIC_COLORS.primary80,
  backgroundFilledAccentActive: _semantic_colors.SEMANTIC_COLORS.accent80,
  backgroundFilledAccentSecondaryActive: _semantic_colors.SEMANTIC_COLORS.accentSecondary80,
  backgroundFilledNeutralActive: _semantic_colors.SEMANTIC_COLORS.neutral80,
  backgroundFilledSuccessActive: _semantic_colors.SEMANTIC_COLORS.success80,
  backgroundFilledWarningActive: _semantic_colors.SEMANTIC_COLORS.warning60,
  backgroundFilledRiskActive: _semantic_colors.SEMANTIC_COLORS.risk70,
  backgroundFilledDangerActive: _semantic_colors.SEMANTIC_COLORS.danger80,
  backgroundFilledTextActive: _semantic_colors.SEMANTIC_COLORS.shade80,
  backgroundEmptyPrimaryHover: _semantic_colors.SEMANTIC_COLORS.primary70Alpha16,
  backgroundEmptyAccentHover: _semantic_colors.SEMANTIC_COLORS.accent70Alpha16,
  backgroundEmptyAccentSecondaryHover: _semantic_colors.SEMANTIC_COLORS.accentSecondary70Alpha16,
  backgroundEmptyNeutralHover: _semantic_colors.SEMANTIC_COLORS.neutral70Alpha16,
  backgroundEmptySuccessHover: _semantic_colors.SEMANTIC_COLORS.success70Alpha16,
  backgroundEmptyWarningHover: _semantic_colors.SEMANTIC_COLORS.warning60Alpha12,
  backgroundEmptyRiskHover: _semantic_colors.SEMANTIC_COLORS.risk60Alpha12,
  backgroundEmptyDangerHover: _semantic_colors.SEMANTIC_COLORS.danger70Alpha16,
  backgroundEmptyTextHover: _semantic_colors.SEMANTIC_COLORS.plainLightAlpha12,
  backgroundEmptyPrimaryActive: _semantic_colors.SEMANTIC_COLORS.primary70Alpha20,
  backgroundEmptyAccentActive: _semantic_colors.SEMANTIC_COLORS.accent70Alpha20,
  backgroundEmptyAccentSecondaryActive: _semantic_colors.SEMANTIC_COLORS.accentSecondary70Alpha20,
  backgroundEmptySuccessActive: _semantic_colors.SEMANTIC_COLORS.success70Alpha20,
  backgroundEmptyNeutralActive: _semantic_colors.SEMANTIC_COLORS.neutral70Alpha20,
  backgroundEmptyWarningActive: _semantic_colors.SEMANTIC_COLORS.warning60Alpha16,
  backgroundEmptyRiskActive: _semantic_colors.SEMANTIC_COLORS.risk60Alpha16,
  backgroundEmptyDangerActive: _semantic_colors.SEMANTIC_COLORS.danger70Alpha20,
  backgroundEmptyTextActive: _semantic_colors.SEMANTIC_COLORS.plainLightAlpha16,
  textColorFilledWarning: _semantic_colors.SEMANTIC_COLORS.warning110
});
var buttons = exports.buttons = {
  LIGHT: _buttons,
  DARK: _dark_buttons
};